const audio = new Audio('/ringtone.mp3');
audio.loop = true;
audio.volume = 0.7;

export function playRingtone() {
  try {
    //navigator.vibrate([300, 2500, 300, 2500, 300, 2500, 300, 2500, 300, 2500, 300, 2500]);
    audio.play();
  } catch (e) {}
}

export function pauseRingtone() {
  try {
    // navigator.vibrate([]);
    audio.pause();
    audio.currentTime = 0;
    audio.load();
  } catch (e) {}
}
